var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-logo-gifas-white';
                    var viewUrl = 'sprite.svg#view-icon-logo-gifas-white';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-logo-gifas-white#icon-logo-gifas-white';
                            viewUrl = 'sprite.svg?icon-logo-gifas-white#view-icon-logo-gifas-white';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 195.4 52.2',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };